"use client";

import { FC } from "react";
import SalifyFormTextFieldWrapper, {
  SalifyFormTextFieldWrapperProps,
} from "./common/text-field-wrapper";

const SalifyFormTextFieldPhone: FC<SalifyFormTextFieldWrapperProps> = ({
  field,
  textFieldProps,
}) => {
  return (
    <SalifyFormTextFieldWrapper
      field={field}
      textFieldProps={{
        ...textFieldProps,
        inputProps: {
          ...textFieldProps?.inputProps,
          inputMode: "tel",
          maxLength: 11,
          autoComplete: "tel",
        },
        onChange: (e) => {
          const rawValue = e.target.value.replace(/\D/g, "").slice(0, 11);
          field.handleChange(rawValue);
        },
      }}
    />
  );
};

SalifyFormTextFieldPhone.displayName = "SalifyFormTextFieldPhone";

export default SalifyFormTextFieldPhone;
